var languages = ['fi', 'en', 'sv'];
var defaultLanguage = 'fi';
var datePickerDefaultTexts = {
  en: {
    openButtonLabel: 'Choose date',
    selectedDateLabel: 'Selected date',
    closeButtonText: 'Close',
    selectButtonText: 'Select',
    yearSelectLabel: 'Select year',
    monthSelectLabel: 'Select month',
    nextMonthButtonLabel: 'Next month',
    prevMonthButtonLabel: 'Previous month',
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    weekDayAbbreviations: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
  },
  fi: {
    openButtonLabel: 'Valitse päivämäärä',
    selectedDateLabel: 'Valittu päivä',
    closeButtonText: 'Sulje',
    selectButtonText: 'Valitse',
    yearSelectLabel: 'Valitse vuosi',
    monthSelectLabel: 'Valitse kuukausi',
    nextMonthButtonLabel: 'Seuraava kuukausi',
    prevMonthButtonLabel: 'Edellinen kuukausi',
    monthNames: ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'],
    weekDays: ['maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai', 'sunnuntai'],
    weekDayAbbreviations: ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su']
  },
  sv: {
    openButtonLabel: 'Välj datum',
    selectedDateLabel: 'Valt datum',
    closeButtonText: 'Stäng',
    selectButtonText: 'Välj',
    yearSelectLabel: 'Välj år',
    monthSelectLabel: 'Välj månad',
    nextMonthButtonLabel: 'Nästa månad',
    prevMonthButtonLabel: 'Föregående månad',
    monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
    weekDays: ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag'],
    weekDayAbbreviations: ['Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör', 'Sön']
  }
};

export { datePickerDefaultTexts, defaultLanguage, languages };
//# sourceMappingURL=datePickerTexts.js.map
